export default "__VITE_ASSET__DRtYwVAy__"